import React, { PropTypes } from 'react';
import DataService from '../../lib/DataService';
import SharedTools from '../../lib/SharedTools';
import CurrentRoleStore from '../../stores/CurrentRoleStore';
import { hashHistory, Link } from 'react-router';
import { Select, message } from 'antd';

const Option = Select.Option;


export default class ArchiveBookStudentsListPage extends React.Component {
  static propTypes = {
    // name: PropTypes.string.isRequired
  };

  constructor(props) {
    super(props);
    // set state
    this.state = {
      role: CurrentRoleStore.getCurrentRole(),
      students: [],
      classId: props.params.classId,
      semester: props.location.query.semester,
      semesters: []
    };
    // bind this
    this.toRecordDetail = this.toRecordDetail.bind(this);
  }

  componentDidMount() {
    CurrentRoleStore.addChangeListener(this.onRolesChange);
    let semester = this.state.semester;
    let currentSemester = SharedTools.getCurrentSemester();
    DataService.getClassById(this.state.classId).then(result => {
      if (result.archive_semester_count == 1) {
        semester = String(semester).substring(0, 4) + '1';
      } else {
        semester = semester;
      }
      let semesters = SharedTools.getAllSemesters(currentSemester, SharedTools.getCurrentSemester(result.created_at), result.archive_semester_count);
      this.setState({
        semester,
        semesters
      }, () => {
        this.getArchives()
      })
    }).catch((error) => {
      console.log(error)
    })

  }

  getArchives() {
    DataService.getArchives(this.state.classId, this.state.semester).then((archive) => {
      DataService.getClassProgress(archive.id).then((res) => {
        this.setState({
          students: res.students,
        })
      }).catch((error) => {
      })
    }).catch((error) => {
      message.error('该学期暂无档案！')
      this.setState({
        students: []
      })
    })
  }

  componentWillUnmount() {
    CurrentRoleStore.removeChangeListener(this.onRolesChange);
  }

  toRecordDetail(e) {
    let studentId = e.currentTarget.dataset.id, name = e.currentTarget.dataset.name;
    hashHistory.push(`archive/book/classes/${this.state.classId}/students/${studentId}?studentName=${name}&semester=${this.state.semester}`);
  }

  selectSemester(value) {
    if (value != this.state.semester) {
      this.setState({
        semester: value,
      }, () => {
        this.getArchives()
        this.props.location.query.semester = value;
        hashHistory.replace(this.props.location);
      })
    }
  }

  _selectSemesterBox() {
    return (
      <div className="select-semester-box">
        <Select value={String(this.state.semester)} style={{ width: 145 }} onChange={this.selectSemester.bind(this)}>
          {this.state.semesters.map((semester, index) => <Option value={String(semester.semester)} key={index}>{semester.semesterToString}</Option>)}
        </Select>
      </div>
    )
  }

  render() {
    return (
      <div className="albums-record-index-page archive-content-setting-class-page">
        {this._selectSemesterBox()}
        <div className="record-wrapper">
          <div className="student-list">
            <div className="student-list-box top">
              <span className="student-name">姓 名</span>
              <div className="student-info">
                <div className="student-record">
                  <div>总进度</div>
                </div>
                <div className="student-record">
                  <div>家长完成度</div>
                </div>
                <div className="student-record">
                  <div>老师完成度</div>
                </div>
              </div>
            </div>
            {this.state.students.map(student =>
              <div key={student.id} data-id={student.id} data-name={student.full_name} className="student-list-box" onClick={this.toRecordDetail}>
                {student.avatar_url ? <img src={student.avatar_url} /> : <div className="no-avatar"></div>}
                <span className="student-name">{student.full_name}</span>
                <div className="student-info">
                  <div className="student-record">
                    <div>已有{student.complete_count}/{student.page_count} 待审核{student.need_review}</div>
                  </div>
                  <div className="student-record">
                    <div>家长提交{student.parent_complete_count}/{student.parent_page_count}</div>
                  </div>
                  <div className="student-record">
                    <div>老师提交{student.teacher_complete_count}/{student.teacher_page_count}</div>
                  </div>
                </div>
              </div>
            )}
            {(this.state.students.length == 0) && <div className="no-student">暂无学生哦~</div>}
          </div>
        </div>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./app/javascript/bundles/WebPcApp/components/archive/ArchiveBookStudentsListPage.jsx